import type { WorkshopDate } from '~/types/supabase'

export const isUpcomingWorkshop = (
  date: Pick<WorkshopDate, 'is_active' | 'start_date'> | null,
  today = new Date().toISOString().slice(0, 10)
): boolean => Boolean(date?.is_active && date.start_date && date.start_date.slice(0, 10) >= today)
